import { deleteFileV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function deleteFile({ folder, fileUuid }: { folder: string; fileUuid: string }): Promise<void> {
  await deleteFileV2(folder, fileUuid)
}
